

















import { Vue, Component, Prop } from "vue-property-decorator";
import PrizeSelect from "./prize-select/index.vue";

@Component({
  components: {
    PrizeSelect
  }
})
export default class ScratchCardPrize extends Vue {
  @Prop({
    type: Array,
    default: () => {
      return [];
    }
  })
  value!: Array<any>;
  columns = [
    {
      title: "奖品名称",
      key: "name"
    },
    {
      title: "数量",
      key: "quantity",
      render: (h, params) => {
        return h("InputNumber", {
          props: {
            value: this.value[params.index].quantity,
            min: 0
          },
          on: {
            "on-change": (event: number) => {
              this.value[params.index].quantity = event;
            }
          }
        });
      }
    },
    {
      title: "中奖概率",
      key: "rate",
      render: (h, params) => {
        return h("InputNumber", {
          props: {
            value: this.value[params.index].rate,
            min: 1,
            max: 100
          },
          on: {
            "on-change": (event: number) => {
              this.value[params.index].rate = event;
            }
          }
        });
      }
    },
    {
      title: "操作",
      key: "action",
      slot: "action"
    }
  ];
  onPrizeChange(e) {
    console.log("on prize change", e);
    let item = {
      prizeType: e.type,
      couponId: e.type === 0 ? e.value : "",
      couponType: e.type === 0 ? e.couponType : "",
      discountValue: e.type === 0 ? e.discountValue : "",
      rewardPoint: e.type === 1 ? e.value : 0,
      name: e.name,
      pictureUrl: "",
      quantity: 0,
      winQuantity: 0,
      remainQuantity: 0,
      rate: 0,
      id: ""
    };
    this.value.push(item);
  }
  remove(index: number) {
    this.value.splice(index, 1);
  }
  save() {
    this.$emit("on-save");
  }
}
